/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Outline_LabelInputs */

const en_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline`)
};

const fr_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contour`)
};

const de_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gliederung`)
};

const it_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

const ru_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контур`)
};

const es_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describir`)
};

const zh_cn2_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大纲`)
};

const ja_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const hi_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूपरेखा`)
};

const pt_pt2_styles_outline_label = /** @type {(inputs: Styles_Outline_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contorno`)
};

/**
* | output |
* | --- |
* | "Outline" |
*
* @param {Styles_Outline_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_outline_label = /** @type {((inputs?: Styles_Outline_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Outline_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_outline_label(inputs)
	if (locale === "de") return de_styles_outline_label(inputs)
	if (locale === "it") return it_styles_outline_label(inputs)
	if (locale === "ru") return ru_styles_outline_label(inputs)
	if (locale === "es") return es_styles_outline_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_outline_label(inputs)
	if (locale === "ja") return ja_styles_outline_label(inputs)
	if (locale === "hi") return hi_styles_outline_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_outline_label(inputs)
	return en_styles_outline_label(inputs)
});